export const environment = {
  production: true,
  apiUrl: "https://api.greendot.click",
  // apiUrl: "http://localhost:8080",

  //new
  GoogleMapapiKey: `AIzaSyBxVZ-Wog61YMTAOQl_CtgBTQA42i6F_gk`,
};


